<template>
  <div class="editCertificate" style="border:1px solid #e0e0e0;">
    <div class="titleForm-container">证书管理</div>
    <div class="content-form-container">
      <div class="main-container-form">
        <el-form :model="baseForm" :rules="rules" ref="baseForm" label-width="100px" class="ruleForm">
          <el-form-item label="公司名称" prop="name">
            <el-input v-model="baseForm.name" size="medium" style="width:100%;" disabled placeholder="请输入真实姓名" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" >
            </el-input>
          </el-form-item>
          <el-form-item label="相关图片" prop="images">
            <div class="uploadWall">
              <base-upload v-for="(item1,index) in list" :key="index" :listObj="item1" :disabled="!edit" @transImg="transImg" @removeImg="removeImg"></base-upload>
            </div>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
          </el-form-item>
          <el-form-item class="save-cancel" v-if="edit">
            <el-col :span="8">
              <el-button class="save-btn" style="width:200px;" @click="saveBase()">保存</el-button>
            </el-col>
            <!-- <el-col :span="8">
              <el-button class="cancel-btn" @click="cancelForm()">取消</el-button>
            </el-col> -->
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>


<script>
import { mapActions, mapState } from "vuex";
import { modules } from "../../../store";
import imgUpload from "../../../service/base-url";
import BaseUpload from "./BaseUpload";
import mixins from "@/common/MixIn.js";
export default {
  name: "editCertificate",
  mixins: [mixins],
  components: {
    BaseUpload
  },
  data() {
    return {
      uploadList: {
        idCardFront: "",
        idCardReverse: "",
        driverLicense: "",
        transportPermit: "",
        drivingLicense: "",
        photo: ""
      },
      list: [
        {
          certificateType: 1,
          remark: 1,
          hide: false,
          uploadURl: imgUpload.imgUpload + "?Remark=1",
          url: "",
          tip: "点击上传QS证书",
          desc: "QS证书"
        },
        {
          certificateType: 2,
          remark: 2,
          hide: false,
          uploadURl: imgUpload.imgUpload + "?Remark=2",
          url: "",
          tip: "点击上传绿色食品证书",
          desc: "绿色食品"
        },
        {
          certificateType: 3,
          remark: 3,
          hide: false,
          uploadURl: imgUpload.imgUpload + "?Remark=3",
          url: "",
          tip: "点击上传SGS证书",
          desc: "SGS证书"
        },
        {
          certificateType: 4,
          remark: 4,
          hide: false,
          uploadURl: imgUpload.imgUpload + "?Remark=4",
          url: "",
          tip: "点击上传HACCP证书",
          desc: "HACCP证书"
        },
        {
          certificateType: 5,
          remark: 5,
          hide: false,
          uploadURl: imgUpload.imgUpload + "?Remark=5",
          url: "",
          tip: "点击上传无公害农产品证书",
          desc: "无公害农产品"
        }
        // {
        //   certificateType: 6,
        //   hide: false,
        //   uploadURl: imgUpload.imgUpload + "?CertificateType=6",
        //   url: "",
        //   tip: "点击上传司机与车辆合照",
        //   desc: "司机与车辆合照"
        // }
      ],
      imgList: [],
      imageUrl: "",
      dialogImageUrl: "",
      dialogVisible: false,
      index: "",
      // 参数
      baseForm: {
        id: "",
        name: "",
        images: [] //图片
      },
      // 校验规则
      rules: {},
      uploadURl: imgUpload.imgUpload // 文件上传地址
    };
  },
  async mounted() {
    await this.initPagePermission();
    this.$api.getCompanyName().then(rsp => {
      let result = rsp.data;
      this.baseForm.id = result.id;
      this.baseForm.name = result.name;
    });

    this.$api.getCertificate().then(data => {
      this.showImg(data.data);
    });
  },
  methods: {
    ...mapActions(modules.driverManage, {
      getSingleDriver: "getSingleDriver",
      updateDriver: "updateDriver"
    }),
    distribution(arr) {
      this.baseForm.images = [];
      arr.forEach(ele => {
        this.baseForm.images.push({
          image: ele.name,
          certificateType: Number(ele.remark)
        });
      });
    },
    showImg(obj) {
      obj.forEach(ele => {
        switch (ele.certificateType) {
          case 1:
            this.list[0].url = this.uploadURl + "/" + ele.image;
            break;
          case 2:
            this.list[1].url = this.uploadURl + "/" + ele.image;
            break;
          case 3:
            this.list[2].url = this.uploadURl + "/" + ele.image;
            break;
          case 4:
            this.list[3].url = this.uploadURl + "/" + ele.image;
            break;
          case 5:
            this.list[4].url = this.uploadURl + "/" + ele.image;
            break;
        }

        ele.name = ele.image;
        ele.remark = ele.certificateType;
        this.imgList.push(ele);
      });
    },
    // 上传图片
    transImg(res) {
      console.log(99, res);
      let haveEqual = this.imgList.find((item, index) => {
        if (item.remark == res.remark) {
          this.imgList.splice(index, 1, res);
          return true;
        }
      });
      if (!haveEqual) {
        this.imgList.push(res);
      }
      console.log(311, this.imgList);
    },
    // 删除图片
    removeImg(e) {
      console.log(1111, e);
      this.imgList.find((item, index) => {
        console.log(item);
        if (item.certificateType == e) {
          this.imgList.splice(index, 1);
          return true;
        }
      });
    },
    //保存
    async saveBase(formName) {
      this.distribution(this.imgList);
      console.log(98, this.imgList);

      let obj = {
        enterpriseId: this.baseForm.id,
        details: this.baseForm.images
      };
      this.$api
        .editCertificate(obj)
        .then(data => {
          this.$message({
            message: "保存成功",
            type: "success"
          });
          this.cancelForm();
        })
        .catch(err => {
          this.$Alert.info({
            content: err.response.data,
            duration: 5000,
            status: "error"
          });
        });

      console.log(97, obj);
    },
    //取消
    async cancelForm() {
      this.imgList = [];
      let result = await this.$api.getCompanyName();
      this.baseForm.id = result.data.id;
      this.baseForm.name = result.data.name;
      let data = await this.$api.getCertificate();
      this.showImg(data.data);
    }
  }
};
</script>
<style lang="stylus">
.uploadWall
  display flex !important;
  flex-direction row
  flex-wrap wrap 
  width:700px;
  >div
    margin-right:50px;
</style>

<style lang="stylus" scoped>
.desc
  text-align center;
  color:#666;
</style>
